import { Modal } from "antd";
import { PlateProductionAddbyCount } from "./PlateProductionAddbyCount";
import { PlateProductionAddbyList } from "./PlateProductionAddbyList";

const PlateProductionModal = ({
  isOpenModal,
  title,
  setIsOpenModal,
  platesRefetch,
  modalType,
}) => {
  return (
    <div className="container-fluid mx-auto ">
      <Modal
        open={isOpenModal}
        closable={false}
        onCancel={() => setIsOpenModal(false)}
        footer={null}
        width={580}
        centered
        title={title}
        destroyOnClose
      >
        {modalType === "addByCount" ? (
          <PlateProductionAddbyCount
            isModalForm={true}
            onCancel={() => setIsOpenModal(false)}
            platesRefetch={platesRefetch}
          />
        ) : modalType === "addByList" ? (
          <PlateProductionAddbyList
            isModalForm={true}
            onCancel={() => setIsOpenModal(false)}
            platesRefetch={platesRefetch}
          />
        ) : null}
      </Modal>
    </div>
  );
};

export default PlateProductionModal;
